/* UserReviewsV2.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { UserReview } from './UserReview';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _9 = "._18u0idpf{margin-left:0}";
const _8 = "._otyridpf{margin-bottom:0}";
const _7 = "._2hwxidpf{margin-right:0}";
const _6 = "._19pkidpf{margin-top:0}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "._n3tdidpf{padding-bottom:0}";
const _3 = "._u5f3idpf{padding-right:0}";
const _2 = "._ca0qidpf{padding-top:0}";
const _ = "._qtt8glyw{list-style:none}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const UserReviewsV2 = _ref2 => {
  let {
    reviews,
    mpacBaseUrl,
    user,
    appKey,
    loginHref,
    filterOutDeletedReview,
    filterOutDeletedVendorResponse,
    vendorName,
    vendorLogo
  } = _ref2;
  return /*#__PURE__*/_jsx(Container, {
    children: reviews.map((review, index) => {
      const vendorDetails = _objectSpread({
        name: vendorName,
        logo: vendorLogo
      }, review.vendor);
      return /*#__PURE__*/_jsx(UserReview, _objectSpread(_objectSpread({}, review), {}, {
        index: index,
        mpacBaseUrl: mpacBaseUrl,
        filterOutDeletedReview: filterOutDeletedReview,
        filterOutDeletedVendorResponse: filterOutDeletedVendorResponse,
        user: user,
        appKey: appKey,
        loginHref: loginHref,
        vendorDetails: vendorDetails
      }), review.id);
    })
  });
};
export default UserReviewsV2;